module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "index-main"
  }, [_c('x-button', {
    attrs: {
      "link": "/evaluation/one",
      "type": "primary"
    }
  }, [_vm._v("风险测评")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/investor/personal/one",
      "type": "primary"
    }
  }, [_vm._v("投资者信息-个人")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/investor/agency/one",
      "type": "primary"
    }
  }, [_vm._v("投资者信息-机构")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/investor/product/one",
      "type": "primary"
    }
  }, [_vm._v("投资者信息-产品")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/agreeupdate/index",
      "type": "primary"
    }
  }, [_vm._v("服务协议及隐私变更通知")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/manager/login",
      "type": "primary"
    }
  }, [_vm._v("管理人-登录与注册")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/share/index?type=SPECIFIC_PERSONAL_PRACTITIONERS",
      "type": "primary"
    }
  }, [_vm._v("投资者分享")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/relation?name=杨老五杨老五杨老五杨老五杨老五&type=SPECIFIC_PERSONAL_PRACTITIONERS&code=123456",
      "type": "primary"
    }
  }, [_vm._v("关联成功分享")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/download",
      "type": "primary"
    }
  }, [_vm._v("app下载")]), _vm._v(" "), _c('x-button', {
    attrs: {
      "link": "/guide/list",
      "type": "primary"
    }
  }, [_vm._v("app操作手册")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('my-step', {
    attrs: {
      "step": 2,
      "totalstep": 3
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "AU"
    },
    model: {
      value: (_vm.au),
      callback: function($$v) {
        _vm.au = $$v
      },
      expression: "au"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b1d9de0"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 1072
// module chunks = 1